<template>
<layout-crumb :opts="[{label: task.siteName}, {label: $route.meta.label}]">
  <section class="selector-wrapper">
    <section class="selector-body">
      <section class="selector-left">
        <ul class="device-category-list-menu">
          <li
            v-for="deviceCategory in deviceCategoryList"
            :key="deviceCategory.id"
            :class="{selected: deviceCategory.id === selectedDeviceCategoryId}"
            class="device-category-list-menu-item"
            @click="onDeviceCategoryMenuClick(deviceCategory)"
          >{{deviceCategory.name}}</li>
        </ul>
      </section>

      <section class="selector-content">
        <section v-if="currentTaskDeviceList.length > 0">
          <van-swipe-cell
            v-for="(taskDevice, index) in currentTaskDeviceList"
            v-if="deviceMap[taskDevice.deviceId]"
            :key="index"
          >
            <van-cell
              :title="deviceMap[taskDevice.deviceId].name"
              :value="taskDevice.serialNumber"
              :label="`启用日期：${taskDevice.startDate || '--'}`"
              is-link
              @click="onTaskDeviceItemClick(taskDevice)"
            />

            <template #right>
              <van-button square type="danger" text="删除" @click="onTaskDeviceDelBtnClick(taskDevice)" />
            </template>
          </van-swipe-cell>
        </section>
        <van-empty v-else>
          <p class="van-empty__description" style="margin-top:-24px;text-align:center;">
            本站点下没有<span style="color:#409EFF;">{{deviceCategoryMap[selectedDeviceCategoryId] ? deviceCategoryMap[selectedDeviceCategoryId].name : ''}}</span>类型的仪器, <br />如需添加该类型仪器, 请点击下方的<span style="color:#FE7300;" @click="onCreateTaskDeviceBtnClick">添加站房仪器</span>按钮
          </p>
        </van-empty>
      </section>
    </section>

    <section class="selector-footer">
      <button class="back-btn" @click="onPreStepClick">返回运维组织</button>
      <Abort />
      <button class="create-btn" @click="onCreateTaskDeviceBtnClick">添加站房仪器</button>
      <button class="next-btn" style="width:120px;" @click="onNextStepClick">下一步</button>
    </section>
  </section>

  <van-action-sheet
    v-model="deviceSelectVisible"
    show-toolbar
    description="选择仪器"
    :actions="[...currentCategoryDeviceList, {id:'',name:'没有想要的仪器？去添加新的仪器',text:'没有想要的仪器？去添加新的仪器'}]"
    :style="{height:'100%'}"
    cancel-text="取消"
    @select="onDeviceSelectSelect"
    @cancel="onDeviceSelectCancel"
  />

  <van-popup
    v-if="deviceModel"
    v-model="deviceInputVisible"
    position="bottom"
    round
    closeable
  >
    <div style="font-size:16px;line-height:44px;padding:0 16px;">添加仪器</div>
    <van-form @submit="onDeviceSubmit">
      <van-field
        v-model="deviceModel.brand"
        name="仪器品牌"
        label="仪器品牌"
        placeholder="仪器品牌"
        :rules="[{required:true,message:'请填写仪器品牌'}]"
      />

      <van-field
        v-model="deviceModel.model"
        name="仪器型号"
        label="仪器型号"
        placeholder="仪器型号"
        :rules="[{required:true,message:'请填写仪器型号'}]"
      />

      <div style="margin:16px;">
        <van-button round block type="info" native-type="submit">确定</van-button>
      </div>
    </van-form>
  </van-popup>

  <van-popup
    v-if="taskDeviceModel"
    v-model="deviceSNVisible"
    position="bottom"
    round
    closeable
  >
    <div style="font-size:16px;line-height:44px;padding:0 16px;">添加站房仪器</div>
    <van-form @submit="onTaskDeviceSubmit">
      <section class="add-site-device-form">
        <van-field
          v-model="taskDeviceModel.serialNumber"
          name="仪器序列号"
          label="仪器序列号"
          placeholder="仪器序列号"
          :rules="[{required:true,message:'请填写仪器序列号'}]"
        />

        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="taskDeviceModel.startDate"
          label="启用日期"
          placeholder="点击选择仪器启用日期"
          :rules="[{required:true,message:'请选择仪器启用日期'}]"
          @click="onDeviceInputClick"
        />
        <section class="image-wrapper">
          <data-image
            :img-host="taskDeviceModel.fileStr ? 'data:image/jpeg;base64,' : IMAGE_HOST"
            :img-obj="taskDeviceModel.fileStr || taskDeviceModel.photoPath ? taskDeviceModel : null"
            :file-prop="taskDeviceModel.fileStr ? 'fileStr' : 'photoPath'"
            style="width:100%;height:100%;"
            @take-photo="onTakePhoto"
            @img-click="onImgClick"
          />
        </section>
      </section>

      <div style="margin:16px;">
        <van-button round block type="info" native-type="submit">确定</van-button>
      </div>
    </van-form>
  </van-popup>

  <van-popup v-model="showDeviceStartDate" position="bottom">
    <van-datetime-picker
      v-model="currentDate"
      type="date"
      @confirm="onDeviceStartDateConfirm"
      @cancel="showDeviceStartDate = false"
    />
  </van-popup>

  <van-action-sheet
    v-model="imgOptsVisible"
    :actions="imageActions"
    cancel-text="取消"
    @select="onImageOptClick"
  />

  <van-overlay :show="overlayVisible">
    <van-loading type="spinner" />
  </van-overlay>
</layout-crumb>
</template>

<script>
import {mapGetters} from 'vuex'
import {Toast, ImagePreview} from 'vant'

const IMAGE_HOST = process.env.IMAGE_HOST

export default {
  name: 'index',
  routeInfo: {
    label: '站房仪器'
  },
  data () {
    return {
      deviceSelectVisible: false,
      deviceCategoryList: [],
      deviceList: [],
      selectedDeviceCategoryId: 0,
      taskDeviceModel: null,
      deviceModel: null,
      deviceInputVisible: false,
      deviceSNVisible: false,
      showDeviceStartDate: false,
      overlayVisible: false,
      currentDate: new Date(),
      imgOptsVisible: false
    }
  },
  computed: {
    IMAGE_HOST: () => IMAGE_HOST,
    ...mapGetters({
      task: 'Task/task',
      taskNum: 'Task/taskNum'
    }),
    taskDeviceList () {
      return this.task.taskDeviceList
    },
    imageActions () {
      return [{
        value: 'PREVIEW',
        name: '预览图片',
        callback: this.previewImage
      }, {
        value: 'DELETE',
        name: '清除图片',
        callback: this.deleteImage
      }]
    },
    deviceMap () {
      return this.deviceList.reduce((map, device) => {
        map[device.id] = device
        return map
      }, {})
    },
    categoryDeviceMap () {
      return Object.freeze(this.deviceList.reduce((map, device) => {
        let deviceList = map[device.categoryId]

        if (!deviceList) {
          deviceList = map[device.categoryId] = []
        }

        deviceList.push(Object.freeze(device))
        return map
      }, {}))
    },
    currentCategoryDeviceList () {
      return this.categoryDeviceMap[this.selectedDeviceCategoryId] || []
    },
    deviceCategoryMap () {
      return this.deviceCategoryList.reduce((map, deviceCategory) => {
        map[deviceCategory.id] = deviceCategory
        return map
      }, {})
    },
    currentTaskDeviceList () {
      let {selectedDeviceCategoryId} = this
      return this.taskDeviceList.filter(({deviceCategoryId}) => deviceCategoryId === selectedDeviceCategoryId)
    }
  },
  methods: {
    getTaskDeviceModel () {
      return {
        deviceBrand: '',
        deviceCategoryId: this.selectedDeviceCategoryId,
        deviceId: '',
        deviceModel: '',
        deviceName: '',
        fileStr: null,
        id: null,
        photoPath: null,
        serialNumber: '',
        siteDeviceId: '',
        startDate: '',
        taskId: this.task.id
      }
    },
    getDeviceModel () {
      return {
        id: '',
        brand: '',
        model: '',
        categoryId: this.selectedDeviceCategoryId
      }
    },
    getDeviceList () {
      this.$api.Device.getList().then(deviceList => {
        deviceList.forEach(device => {
          device.text = device.name
        })

        this.deviceList = Object.freeze(deviceList)
      }).catch(console.error)
    },
    onNextStepClick () {
      let {taskDeviceList} = this

      if (taskDeviceList.length === 0) {
        return Toast('请添加站房仪器')
      }

      let hasNotPhotoPathTaskDeviceList = taskDeviceList.filter(taskDevice => !taskDevice.photoPath)

      if (hasNotPhotoPathTaskDeviceList.length > 0) {
        return Toast(`${hasNotPhotoPathTaskDeviceList.map(taskDevice => `${taskDevice.deviceBrand}${taskDevice.deviceModel}`).join('、')}未上传照片`)
      }

      this.overlayVisible = true
      this.$api.TaskDevice.submit(this.task.id).then(data => {
        if (data) {
          this.$router.replace({
            name: 'MeasureInstrumentSelector'
          })
        }
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onPreStepClick () {
      this.$router.replace({
        name: 'MaintainOrgSelector'
      })
    },
    onDeviceCategoryMenuClick (deviceCategory) {
      this.selectedDeviceCategoryId = deviceCategory.id
    },
    onCreateTaskDeviceBtnClick () {
      this.taskDeviceModel = this.getTaskDeviceModel()
      this.currentTaskDevice = null
      this.deviceSelectVisible = true
    },
    setTaskDeviceFromDevice (device) {
      let taskDeviceModel = this.taskDeviceModel
      taskDeviceModel.deviceId = device.id
      taskDeviceModel.deviceBrand = device.brand
      taskDeviceModel.deviceModel = device.model
      taskDeviceModel.deviceName = device.name
      this.deviceSNVisible = true
    },
    onDeviceSelectSelect (device) {
      let deviceId = device.id

      if (deviceId) {
        this.setTaskDeviceFromDevice(device)
      } else {
        this.deviceModel = this.getDeviceModel()
        this.deviceInputVisible = true
      }

      this.deviceSelectVisible = false
    },
    onDeviceSelectCancel () {
      this.taskDeviceModel = null
      this.deviceSelectVisible = false
    },
    onTaskDeviceSubmit () {
      let {taskDeviceModel} = this

      if (!taskDeviceModel.photoPath && !taskDeviceModel.fileStr) {
        return Toast('当前仪器还未上传照片')
      }

      this.overlayVisible = true

      this.$api.TaskDevice.save(taskDeviceModel).then(data => {
        let {currentTaskDevice} = this

        if (currentTaskDevice) {
          currentTaskDevice.fileStr = null

          for (let key in data) {
            currentTaskDevice[key] = data[key]
          }
        } else {
          data.fileStr = null
          this.taskDeviceList.push(data)
        }

        this.taskDeviceModel = null
        this.currentTaskDevice = null
        this.deviceSNVisible = false
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onTaskDeviceItemClick (taskDevice) {
      this.taskDeviceModel = {
        ...taskDevice
      }
      this.currentTaskDevice = taskDevice
      this.deviceSNVisible = true
    },
    onDeviceSubmit () {
      this.overlayVisible = true

      this.$api.Device.save(this.deviceModel, 1).then(device => {
        if (device) {
          this.getDeviceList()
          this.deviceModel = null
          this.setTaskDeviceFromDevice(device)
          this.deviceInputVisible = false
        }
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onTaskDeviceDelBtnClick (taskDevice) {
      this.overlayVisible = true

      this.$api.TaskDevice.delete(taskDevice.id).then(() => {
        let deleteTaskDeviceId = taskDevice.id
        let {taskDeviceList} = this
        let index = taskDeviceList.findIndex(taskDevice => taskDevice.id === deleteTaskDeviceId)

        if (index > -1) {
          taskDeviceList.splice(index, 1)
        }
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onDeviceInputClick () {
      let {taskDeviceModel: {startDate}} = this

      if (startDate) {
        this.currentDate = new Date(startDate)
      } else {
        this.currentDate = new Date()
      }

      this.showDeviceStartDate = true
    },
    onDeviceStartDateConfirm (date) {
      this.taskDeviceModel.startDate = date.format('YYYY/MM/DD')
      this.showDeviceStartDate = false
    },
    onTakePhoto (base64) {
      this.taskDeviceModel.fileStr = base64.replace(/^data:image\/jpeg;base64,/, '')
    },
    onImgClick (taskDevice) {
      this.imgOptsVisible = true
    },
    onImageOptClick () {
      this.imgOptsVisible = false
    },
    previewImage () {
      ImagePreview({
        images: [`${IMAGE_HOST}${this.taskDeviceModel.photoPath}`],
        startPosition: 0
      })
    },
    deleteImage () {
      this.taskDeviceModel.photoPath = ''
      this.imgOptsVisible = false
    }
  },
  created () {
    this.$api.Device.getCategories().then(deviceCategoryList => {
      deviceCategoryList = this.deviceCategoryList = Object.freeze(deviceCategoryList.filter(deviceCategory => deviceCategory.id > 0))

      if (deviceCategoryList.length > 0) {
        this.selectedDeviceCategoryId = deviceCategoryList[0].id
      }
    }).catch(console.error)

    this.getDeviceList()
  }
}
</script>

<style lang="scss" scoped>
.selector-wrapper {

  .selector-body {
    $DEVICE-SELECTOR-LEFT-WIDTH: 170px;
    padding-left: $DEVICE-SELECTOR-LEFT-WIDTH;
    border-bottom: 1px solid #cfd0d3;

    > .selector-left {
      position: absolute;
      top: 0;
      left: 0;
      width: $DEVICE-SELECTOR-LEFT-WIDTH;
      height: 100%;
      overflow: auto;
      user-select: none;
    }

    .device-category-list-menu {
      min-height: 100%;
      margin: 0;
      padding: 1rem 0 0 1rem;
      border-right: 1px solid #cfd0d3;
      background-color: #FFFEEE;
      /*background-color: rgba(64, 150, 255, 1);*/

      .device-category-list-menu-item {
        width: 100%;
        margin-left: 1px;
        padding-right: 0;
        line-height: 3rem;
        border: 1px solid transparent {
          radius: 3px 0 0 3px;
        };
        transition: all .15s;

        &.selected {
          padding-left: 1rem;
          border: {
            top-color: #cfd0d3;
            right-color: #f7f8fa;
            bottom-color: #cfd0d3;
            left-color: #cfd0d3;
          };
          color: #349efb;
          background-color: #f7f8fa;
        }
      }
    }

    .selector-content {
      width: 100%;
      height: 100%;
      padding: 1rem;
      background-color: #f7f8fa;
      overflow: auto;
    }
  }
}

.device-selector-item {
  display: block;
}

.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}

.add-site-device-form {
  $IMG-WIDTH: 120px;

  position: relative;
  padding-right: $IMG-WIDTH;

  .image-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    width: $IMG-WIDTH;
    height: 88px;
    padding: 0 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04DeviceSelector/index.vue